import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
var _class;
import { PureComponent } from 'react';
import { ResourceView } from './resource-view';
import { engineConfig, observer } from '@alilc/lowcode-editor-core';
import { BuiltinLoading } from '@alilc/lowcode-designer';
import { DesignerView } from '../inner-plugins/webview';
export var WindowView = observer(_class = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(WindowView, _PureComponent);
  function WindowView() {
    return _PureComponent.apply(this, arguments) || this;
  }
  var _proto = WindowView.prototype;
  _proto.render = function render() {
    var active = this.props.active;
    var _this$props$window = this.props.window,
      resource = _this$props$window.resource,
      initReady = _this$props$window.initReady,
      url = _this$props$window.url;
    if (!initReady) {
      var Loading = engineConfig.get('loadingComponent', BuiltinLoading);
      return /*#__PURE__*/React.createElement("div", {
        className: "workspace-engine-main " + (active ? 'active' : '')
      }, /*#__PURE__*/React.createElement(Loading, null));
    }
    if (resource.type === 'webview' && url) {
      return /*#__PURE__*/React.createElement(DesignerView, {
        url: url,
        viewName: resource.name
      });
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "workspace-engine-main " + (active ? 'active' : '')
    }, /*#__PURE__*/React.createElement(ResourceView, {
      resource: resource,
      window: this.props.window
    }));
  };
  return WindowView;
}(PureComponent)) || _class;